import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

export const virtualAccountRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/virtual-account',
  component: lazyRouteComponent(() => import('@/pages/virtual-account/virtual-account-page')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return {
      ...search,
    };
  },
});

export const detailVirtualAccountRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/virtual-account/$id',
  component: lazyRouteComponent(
    () => import('@/pages/virtual-account/detail-virtual-account-page'),
  ),
});
